import type { FC, TeactNode } from '../../../lib/teact/teact';
import React, { memo, useCallback, useRef, useState } from '../../../lib/teact/teact';
import useKeyboardListNavigation from '../../../hooks/useKeyboardListNavigation';
import Modal from '../../ui/Modal';
import Button from '../../ui/Button';
import LotSpinner from '../ui/LotSpinner';
import InputText from '../../ui/InputText';
import hideKeyboard from '../ui/hideKeyboard';
import { ContactsApi } from '../restapi/contactsApi';
import store from '../store';
import { addNewContact, updateCurrentSelectedContact } from '../redux/contactsSlice';
import { LotScreenSettings } from '../config/uiconfig';
import Snackbar from '../ui/snackbar';



type OwnProps = {
    isOpen: boolean;
    onClose: () => void;
    onCloseAnimationEnd?: () => void;
    title?: string;
    header?: TeactNode;
    text?: string;
    confirmLabel?: string;
    confirmHandler: () => void;
    confirmIsDestructive?: boolean;
    areButtonsInColumn?: boolean;
    children?: React.ReactNode;
    isAddNew: boolean;
    onChangeScreen?: (screen: LotScreenSettings) => void;
};

const AddContact: FC<OwnProps> = ({
    isOpen,
    onClose,
    onCloseAnimationEnd,
    title,
    header,
    text,
    confirmLabel = 'Confirm',
    confirmHandler,
    confirmIsDestructive,
    areButtonsInColumn,
    children,
    isAddNew,
    onChangeScreen
}) => {

    const [state, setState] = useState({
        isSaving: false,
        name: "",
        phone: "",
        snackbarMessage:"",
        showSnackbar:false,
    })
    // eslint-disable-next-line no-null/no-null
    const containerRef = useRef<HTMLDivElement>(null);

    const handleSelectWithEnter = useCallback((index: number) => {
        if (index === -1) confirmHandler();
    }, [confirmHandler]);

    const handleKeyDown = useKeyboardListNavigation(containerRef, isOpen, handleSelectWithEnter, '.Button');
    function showSnackbar(message:string){
        setState(prev=>({...prev, snackbarMessage:message, showSnackbar:true}))
    }
    function handleAddContact() {
        hideKeyboard()
        setState({ ...state, isSaving: true })
        if (isAddNew) {
            const payload = { name: state.name, phone: state.phone }
            ContactsApi.createNewContact(payload).then((result:any) => {
                const res = result.data
                if (res.errorCode == 0) {
                    store.dispatch(addNewContact(result.data.data))
                    confirmHandler()
                } else {
                    showSnackbar(result.data.responseText)
                }
                setState((state) => ({ ...state, isSaving: false }))
                
            })
        } else {
            const ct = store.getState().contact
            const payload = {
                fromContactId: ct.currentContact.contactId,
                name: state.name,
                phone: state.phone,
            }
            ContactsApi.postCopyContact(payload).then(result => {
                if (result.errorCode == 0) {
                    store.dispatch(addNewContact(result.data));
                    setState((state) => ({ ...state, isSaving: false }))
                    if (onChangeScreen)
                        onChangeScreen(LotScreenSettings.EDIT_CONTACT_SCREEN)
                } else {

                }
            })
        }
    }
    function handleOnClose() {
        if (!state.isSaving)
            onClose()
    }
    return (
        <Modal
            className="confirm"
            title={title || "BachKhoaSo"}
            header={header}
            isOpen={isOpen}
            onClose={handleOnClose}
            onCloseAnimationEnd={onCloseAnimationEnd}
        >
            {text && text.split('\\n').map((textPart) => (
                <p>{textPart}</p>
            ))}
            {/* {textParts || children} */}
            <InputText
                label='Tên'
                value={state.name}
                onChange={(e) => setState((prev) => ({ ...prev, name: e.target.value }))}
            />
            <InputText
                value={state.phone}
                label='Số điện thoại/ Email'
                onChange={(e) => setState((prev) => ({ ...prev, phone: e.target.value }))}
            />
            <div
                className={areButtonsInColumn ? 'dialog-buttons-column' : 'dialog-buttons mt-2'}
                ref={containerRef}
                onKeyDown={handleKeyDown}
            >

                {!state.isSaving && <Button
                    className="confirm-dialog-button"
                    isText
                    onClick={handleAddContact}
                    color={confirmIsDestructive ? 'danger' : 'primary'}
                >
                    {confirmLabel}
                </Button>
                }
                {
                    state.isSaving && <div style="width:7.25rem;display:flex;flex-direction:column; align-items:center;"> <LotSpinner /> </div>
                }
                <Button
                    disabled={state.isSaving}
                    className="confirm-dialog-button" isText onClick={onClose}>Đóng</Button>
            </div>
            <Snackbar isOpen={state.showSnackbar} message={state.snackbarMessage} triggerTime=''
                onClose={()=>setState(prev=>({...prev,showSnackbar:false}))}
            ></Snackbar>
        </Modal>
    );
};

export default memo(AddContact);
